<template>
  <div class="project-task">
    <div class="flex justify-content-space-between align-items-center pt mb">
      <div class="view-switch text-muted">
        <span role="button" :class="activeView == 'list' && 'active'" class="btn flex-center"
          @click="switchView('list')"><i class="el-icon-s-operation"></i></span>

        <span role="button" :class="activeView == 'board' && 'active'" class="btn flex-center"
          @click="switchView('board')"><i class="el-icon-menu"></i></span>

        <span role="button" :class="activeView == 'gatt' && 'active'" class="btn flex-center"
          @click="switchView('gatt')"><i class="el-icon-s-data"></i></span>
      </div>

      <div v-if="activeView == 'board'" class="board-dropdown">
        <el-dropdown trigger="click" placement="bottom" @command="handleCommandChange">
          <span class="flex align-items-center">
            <i class="el-icon-data-analysis font-md text-bold"></i>
            <span class="ml-xs mr-xs">{{ activeText }}</span>
            <i class="el-icon-arrow-down text-bold"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="1">按阶段</el-dropdown-item> -->
            <el-dropdown-item command="2">按优先级</el-dropdown-item>
            <el-dropdown-item command="3">按负责人</el-dropdown-item>
            <el-dropdown-item command="4">按状态</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="task-content">
      <TaskList v-if="activeView == 'list'" v-loading="loading" :list="list" :projectid="projectid"
        @change="fetchData(1)" />
      <TaskBoard v-if="activeView == 'board'" v-loading="loading" :list="list" :projectid="projectid"
        @change="fetchData(1)" />
      <TaskGatt v-if="activeView == 'gatt'" v-loading="loading" :list="list" :projectid="projectid"
        @change="fetchData(1)" />
    </div>
  </div>
</template>

<script>

export default {
  components: {
    TaskList: () => import('../task/TaskList.vue'),
    TaskBoard: () => import('../task/TaskBoard.vue'),
    TaskGatt: () => import('../task/TaskGatt.vue')
  },

  props: {
    projectid: {
      type: [Number, String],
      default: null
    }
  },

  data () {
    return {
      loading: false,

      activeView: 'list',
      activeText: '按优先级',
      // activeCommand: 2, 
      commandMpa: {
        1: '',
        2: 'priority',
        3: 'principal',
        4: 'status'
      },
      // list: []
    }
  },

  computed: {
    activeCommand: {
      get () {
        return this.$store.state.middleStore.activeCommand
      },
      set (val) {
        this.$store.dispatch('setCommand', val)
      }
    },
    list () {
      return this.$store.state.middleStore.taskList
    }
  },

  async created () {
    this.activeView = localStorage.getItem('__PROJECT_TASK_VIEW__') || 'list'
    this.fetchData()
  },


  methods: {
    async fetchData (flag) {
      let res
      if (!flag) this.loading = true
      await this.$store.dispatch('getAllProjectCardTask')
      if (!flag) this.loading = false
      // if (!res.errno) {
      // 	// this.list = res.data.list
      // } else {
      // 	this.$message.error(res.message)
      // }

    },

    switchView (e) {
      this.activeView = e
      localStorage.setItem('__PROJECT_TASK_VIEW__', e)
      this.fetchData()
    },

    handleCommandChange (e) {
      this.activeCommand = e
      if (e == 1) {
        this.activeText = '按阶段'
      } else if (e == 2) {
        this.activeText = '按优先级'
      } else if (e == 3) {
        this.activeText = '按负责人'
      } else if (e == 4) {
        this.activeText = '按状态'
      }
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
$--pm-detail-active-color: #07c160;

.project-task {
  width: 100%;
  height: 100%;

  .view-switch {
    width: 120px;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    font-size: 26px;

    .btn {
      width: 40px;
      height: 40px;
      background-color: #fff;

      &:hover {
        color: $--pm-detail-active-color;
      }
    }

    .active {
      color: $--pm-detail-active-color;
    }
  }

  .board-dropdown {
    height: 40px;
    padding: 0 15px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    background-color: #fff;
  }

  .task-content {
    height: calc(100% - 70px);
    position: relative;
    overflow-x: auto;
  }
}
</style>

<style lang="scss">
.my-dropdown3 {
  width: 100%;

  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
  border-radius: 4px;
}

.down-item {
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(153, 153, 153, 0.2);
  }
}
</style>